export default __webpack_public_path__ + "static/media/Logo_Gonak.75123e42.png";